
import { request } from "../api";

export const getContactData = async (id) => {
    return await request.get(`/student/registration/generate-contact-letter/${id}`);
};  